import { environment } from '../../environments/environment';

export class Log {

    public static debug(text: any) {

        if (environment.onecontrol.logEnabled) {
            console.log(text); 
        }
    }
}
  